/** In-memory invite-токен после загрузки из Firestore (без localStorage). */
const inviteByUid = new Map<string, string>();

export function setSessionInviteToken(uid: string, token: string): void {
  if (!uid || !token.trim()) return;
  inviteByUid.set(uid, token.trim());
}

export function getSessionInviteToken(uid: string): string {
  if (!uid) return '';
  return inviteByUid.get(uid) ?? '';
}

export function clearSessionInviteToken(uid: string): void {
  if (!uid) return;
  inviteByUid.delete(uid);
}
